import React, {
  ButtonHTMLAttributes,
  MouseEvent,
  ReactNode,
  useEffect,
} from "react";
import styles from "./Button.module.scss";
import { intNumberWithSpaces } from "@/shared/helpers/AddSpacesToNumber";
import clsx from "clsx";
import { Spin, Tooltip } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useAppSelector } from "@/shared/hooks";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  name: string;
  children?: ReactNode;
  disabled?: boolean;
  buttontStyle: "default" | "noBG" | "cancelBtn";
  buttonSize?: "middle" | "big";
  onClick?: (e: MouseEvent) => void;
  badgeValue?: number;
  badgeStyle?: string;
  type?: "submit" | "reset" | "button" | undefined;
  noPaddings?: boolean;
  isLoading?: boolean;
  tooltipTitle?: ReactNode;
  dataTestId?: string;
  isFile?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  type = "button",
  name,
  children,
  disabled = false,
  buttontStyle = "default",
  buttonSize = "middle",
  onClick,
  badgeValue,
  badgeStyle,
  noPaddings = false,
  isLoading = false,
  tooltipTitle,
  dataTestId,
  isFile = false,
}) => {
  const { isFileLoading } = useAppSelector((state) => state.app);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(e);
  };

  return (
    <>
      <Tooltip title={tooltipTitle}>
        <button
          onClick={handleClick}
          className={clsx(
            styles.default,
            styles[buttontStyle],
            { [styles.noPaddings]: noPaddings },
            styles[buttonSize],
          )}
          type={type}
          disabled={disabled}
          {...(dataTestId ? { "data-testid": dataTestId } : {})}
        >
          {!!badgeValue && (
            <div
              className={clsx(styles.badge, badgeStyle)}
              data-testid="cart-button-badge"
            >
              {badgeValue <= 9999 ? intNumberWithSpaces(badgeValue) : "9 999+"}
            </div>
          )}
          {children}
          {name}
          {(isLoading || (isFile && isFileLoading)) && (
            <Spin
              indicator={
                <LoadingOutlined style={{ fontSize: "inherrit" }} spin />
              }
            />
          )}
        </button>
      </Tooltip>
    </>
  );
};
